import Desc from './desc/Desc'
import Item from './item/Item'

export default function Timeline(opts={}){
    BaseConstructor.call(this)
    let {container, states=[]} = opts
    let elements = {}
    let context = this

    this.generate = () =>{
        let _desc = new Desc({container:container})
        _desc.generate()
        states.forEach(state=>{
            let item = new Item({container:container,state:state})
            item.generate()
        })
    }

    this.updateStates = (list=[]) =>{
        states = list
        
        this.destroy()
        this.generate()
    }

    this.destroy = () =>{
       $(container).html('') 
    }
}

Timeline.prototype = Object.create(BaseConstructor.prototype)